import { List, ListVariant } from 'src/api';
import { useStore } from 'src/context';
import { isObject } from '../utils';

/**
 * Use Dependency List Answers
 */
const useDependencyListAnswersSecond = <T extends ListVariant | List>(
  list: T[] = []
) => {
  const { results } = useStore();

  return list.filter(listItem => {
    if (!listItem.dependency_second) {
      return true;
    }

    const { answers = '', questionId } = listItem.dependency_second;

    const currentResult = results[questionId];

    if (Array.isArray(currentResult)) {
      const answerList = answers.split('|');
      return currentResult.some(current =>
        answerList.includes(String(current))
      );
    }

    if (isObject(currentResult)) {
      const currentResult_k = Object.keys(currentResult);

      return answers
        .split('|')
        .some(answer => currentResult_k.some(current => current === answer));
    }

    if (!isObject(currentResult) && !Array.isArray(currentResult)) {
      return currentResult === answers;
    }
  });
};

export { useDependencyListAnswersSecond };
